import React, { useState, useEffect } from "react";
import "../styles/Banker.css";
import { getCurrentBankerNumbers } from "../utils/bankerNumbers";

export const Banker = () => {
  const [numbers, setNumbers] = useState([]);
  const [isBlinking, setIsBlinking] = useState(false);

  useEffect(() => {
    const syncNumbers = () => {
      setNumbers(getCurrentBankerNumbers());
    };

    syncNumbers();
    const intervalId = setInterval(syncNumbers, 60000);

    return () => clearInterval(intervalId);
  }, []);

  // Blinking effect every 40s
  useEffect(() => {
    const startBlinking = () => {
      setIsBlinking(true);
      setTimeout(() => {
        setIsBlinking(false);
      }, 5000);
    };

    startBlinking();
    const blinkInterval = setInterval(startBlinking, 40000);

    return () => clearInterval(blinkInterval);
  }, []);

  return (
    <div className={`banker-container ${isBlinking ? "blinking" : ""}`}>
      <div className="banker-title">BANKER</div>
      {numbers.map((number, index) => (
        <div className="number-box" key={index}>
          <span className="number">{number}</span>
        </div>
      ))}
    </div>
  );
};
